import React, { useContext } from 'react';
import { ProductTransactionExportConfigurationContext } from '../../../../../../context/ProductTransactionExportConfigurationContext';
import { ExportConfigurationsPane } from '../../../../../components/ExportItems';

export default function ProductTransactionReportPane() {
  const { productTransactionExportConfigurations, productTransactionExportConfigurationsLoading } = useContext(
    ProductTransactionExportConfigurationContext,
  );

  return (
    <ExportConfigurationsPane
      configurations={[...productTransactionExportConfigurations.values()]}
      loading={productTransactionExportConfigurationsLoading}
    />
  );
}
